import React, { useState } from "react";
import cn from "classnames";
import styles from "./Faq.module.sass";
import Item from "./Item";
import Dropdown from "../../../components/Dropdown";

const items = [
  {
    title: "Général",
    items: [
      {
        title: "Puis-je signer à distance et en présentiel avec Edutio ?",
        content: "Oui, Edutio propose des modes de signatures différents pour toutes situations de formation : Génération de QR code, Génération de code / lien, Signature par mail, Signature par lien. Ainsi, les signatures par emails permettent de signer les feuilles d'émargement à distance tandis que le mode par scan de QR code sera parfait pour les formations en présentiel."
      },
      {
        title: "Edutio assure-t-il mes financements ?",
        content: "Oui, les feuilles de présence et documents générés via Edutio sont acceptés par les financeurs, OPCO, etc..."
      },
      {
        title: "Mes données sont-elles sécurisées ?",
        content: "La protection de vos données est l'une de nos principales priorités. Nos serveurs sont sécurisés par certificat SSL et vos documents sont certifiés via certificat RGS* pour archivés en coffre-fort électronique. Découvrez plus précisément nos normes rigoureuses dans notre politique RGPD qui se veut transparente."
      },
      {
        title: "La triche est-elle possible avec Edutio ?",
        content: "Non, notre système change le QR code à scanner toutes les 7 secondes, ce qui ne permet pas de le scanner pour émarger si la personne n'est pas dans la salle. Vous pouvez générer un nouveau QR code depuis l'application Edutio, qui vous indiquera le nom des apprenants concernés par la triche, la date et le nom de la session concernée, ainsi que l'appareil utilisé. L'horodatage et notre système de comptes sécurisés sont des couches de protections supplémentaires."
      },
      {
        title: "Est-il possible de customiser Edutio à l'effigie de mon école ?",
        content: "Oui, notre équipe est en mesure de vous fournir une solution taillée sur mesure pour vos besoins. Nous pouvons ajuster les couleurs, logos, créer une application dédiée et bien plus."
      },
    ],
  },
  {
    title: "Émargement",
    items: [
      {
        title: "Edutio assure-t-il mes financements ?",
        content: "Oui, les feuilles de présence et documents générés via Edutio sont acceptés par les financeurs, OPCO, etc..."
      },
      {
        title: "Les apprenants ont besoin de s'inscrire ou se connecter ?",
        content: "Oui ! Vos apprenants peuvent se connecter à Edutio pour signer depuis leurs espace personnel. "
      },
      {
        title: "Je peux personnaliser mes sessions de formation ?",
        content: "Oui ! Chaque session de formation est configurable en fonction des besoins et s'adapte à chaque contexte. Après une une séssion de formation, il est possible de générer des feuilles d'émargement, par groupes ou individuellement."
      },
      {
        title: "Comment gérer les absences et justificatifs ?",
        content: "Edutio intègre un système complet de gestion des absences. Les apprenants peuvent soumettre leurs justificatifs d'absence directement via la plateforme, et vous pouvez valider ou rejeter ces justificatifs en un clic. Le système garde une trace de tous les justificatifs et permet un suivi précis de l'assiduité avec historique complet."
      },
    ],
  },
  {
    title: "Extraction",
    items: [
      {
        title: "Puis-je exporter mes données ?",
        content: "Oui, Edutio permet l'extraction complète de vos données à tout moment. Vous pouvez exporter vos feuilles de présence, rapports d'assiduité, statistiques de présence et toutes les données de vos formations dans différents formats (PDF, Excel, CSV)."
      },
      {
        title: "Comment fonctionnent les rapports d'assiduité ?",
        content: "Les rapports d'assiduité d'Edutio permettent d'ajouter des mémos personnalisés et de notifier automatiquement l'entreprise en cas de non-présence de l'élève à une formation. Vous pouvez suivre précisément l'assiduité de chaque apprenant et maintenir une communication transparente avec les entreprises partenaires."
      },
    ],
  },
];

const Team = () => {
  const options = [];
  items.map((x) => options.push(x.title));

  const [category, setCategory] = useState(options[0]);

  return (
    <div className={cn("section", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.top}>
          <div className={cn("stage-small", styles.stage)}>
            Questions fréquentes
          </div>
          <h2 className={cn("h2", styles.title)}>FAQ – Questions fréquentes</h2>
          <div className={styles.info}>
            Découvrez les réponses aux questions les plus courantes sur notre solution d'émargement numérique ou <a href="/contact">Contactez notre support</a>
          </div>
          <div className={styles.nav}>
            {items.map((x, index) => (
              <button
                className={cn(styles.btn, {
                  [styles.active]: x.title === category,
                })}
                onClick={() => setCategory(x.title)}
                key={index}
              >
                {x.title}
              </button>
            ))}
          </div>
          <Dropdown
            className={styles.dropdown}
            value={category}
            setValue={setCategory}
            options={options}
          />
        </div>
        <div className={styles.list}>
          {items
            .find((x) => x.title === category)
            .items.map((x, index) => (
              <Item item={x} key={index} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default Team;
